import * as React from "react";
import "./Accordian.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import faq1 from "../../../Assets/faq1.png";
import { Box, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { VIDEO_LINKS } from "../../../Utils/Constants";
import dataenrich from "../../../Assets/data-enrich-joi-training.svg";
import brevideologo from "../../../Assets/brevideologo.jpg";
import mapframe from "../../../Assets/mapframe.jpg";

export default function Faqscreen({ isMobile }) {
  //training video modal
  const [joiVideo, setJoiVideo] = React.useState();
  const [overviewVideoModal, setOverviewVideoModal] = React.useState(false);

  const openVideoOverview = (item) => {
    setJoiVideo(item);
    handleOpenOverview(item);
  };
  const handleOpenOverview = () => setOverviewVideoModal(true);
  const handleCloseOverview = () => setOverviewVideoModal(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #ffffff",
    boxShadow: 24,
    p: 4,
  };
  return (
    <>
      <div>
        <div className="Faqscreen-main-heading">
          {isMobile ? (
            <p
              style={{
                fontFamily: "Inter",
                fontWeight: "700",
                fontStyle: "Bold",
                fontSize: "18px",
              }}
            >
              FAQ | Glossary
            </p>
          ) : (
            ""
          )}
        </div>
        <div>
          <div className="FaqscreenAccordion-outter">
            <div className="Faqscreen-sub-heading">
              <h3>Atlas Chat Feature</h3>
            </div>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel6-content"
                id="panel6-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>What Data sources are used in Atlas Chat?</h4>
                {/* <h4>What data sources are used in the pilot version of JOI?</h4> */}
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <table>
                    <tbody>
                      <tr>
                        <td className="text-glossary">
                          <strong>INTERNAL APPLICATIONS</strong>
                        </td>
                        <td className="text-glossary">
                          <ul className="ol-faq">
                            {/* <li>Pardot</li> */}
                            <li>Salesforce</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-glossary">
                          <strong>DATA VENDORS</strong>
                        </td>
                        <td className="text-glossary">
                          <ul className="ol-faq">
                            <li>Crunchbase</li>
                            <li>
                              <a
                                href="https://lightcast.io/products/software/gazelle"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#4C87E2",
                                  textDecoration: "underline",
                                }}
                              >
                                Gazelle.AI
                              </a>
                            </li>{" "}
                            <li>Lighcast</li>
                            <li>ZoomInfo</li>
                            <li>PDL</li>
                            <li>State Net</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-glossary">
                          <strong>DATA QUALITY ENRICHMENT</strong>
                        </td>
                        <td className="text-glossary">
                          <ul className="ol-faq">
                            <li>Clearbit</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-glossary">
                          <strong>PUBLICLY AVAILABLE DATA</strong>
                        </td>
                        <td className="text-glossary">
                          <ul className="ol-faq">
                            <li>Extraction & Annotation via RPA</li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </AccordionDetails>
            </Accordion>

            <Accordion className="defaultExpandedAccordion" defaultExpanded>
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="atlas-panel1-content"
                id="atlas-panel1-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>Who can use the Atlas chat feature?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    Atlas is available to all users with access to the JOI
                    platform. You can access Atlas by logging in through JOI or
                    directly via the Atlas tile on your Okta dashboard — no
                    additional sign-up or permissions required.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="atlas-panel2-content"
                id="atlas-panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>How do I start a chat?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    To start a chat, type your message in the 'Message Atlas
                    Chat...' bar at the bottom of the screen and press Enter or
                    click the arrow button to send. If you're accessing Atlas
                    through JOI, select Atlas Chat from the left navigation
                    panel first. If you're logging in via the Atlas tile on your
                    Okta dashboard, you'll land directly in the chat window.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="atlas-panel3-content"
                id="atlas-panel3-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>How long does it take to get a response?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    Responses are available 24/7 with no off-hours. Simple
                    queries are typically answered in under 2 minutes, while
                    more complex questions may take between 5–10 minutes
                    depending on the nature of your request.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="atlas-panel4-content"
                id="atlas-panel4-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>Can I share files, screenshots, or links in chat?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    Currently, file uploads of any kind are not supported in
                    chat. However, you can download files shared with you
                    directly from the chat window.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="atlas-panel5-content"
                id="atlas-panel5-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>Is there a character or message limit?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    Each individual message has a recommended limit of 2,000
                    characters for the best experience. There is no limit to the
                    number of messages you can send in a single session.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="atlas-panel6-content"
                id="atlas-panel6-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>What happens if I get disconnected mid-chat?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    If you lose your connection or close the chat, the session
                    will end. Within an active session, you will be
                    automatically logged out after 30 minutes of inactivity. A
                    notification will appear at the 25-minute mark to let you
                    know the session is about to expire.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="atlas-panel7-content"
                id="atlas-panel7-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>Are my chats saved? If so, how long?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    Chat history is not saved between sessions. Since Atlas Chat
                    is designed to provide the most current information, past
                    conversations are not retained or accessible after a session
                    ends.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="atlas-panel8-content"
                id="atlas-panel8-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>Who can see my chat history?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    Since chat history is not saved after a session ends, there
                    is no stored conversation data to access. Any activity
                    within an active session is only accessible to the
                    development and Legal teams for auditing purposes. As an
                    internal tool, your data is never shared with any external
                    sources.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="atlas-panel9-content"
                id="atlas-panel9-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>
                  What if chat can't resolve my issue — how do I escalate?
                </h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    If Atlas Chat is unable to resolve your issue, you can use
                    the Contact Us feature found in the Help Center within JOI
                    to submit your concern for further follow-up. You can also
                    use the feedback button to the left of the chat window to
                    flag your experience at any time.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="atlas-panel10-content"
                id="atlas-panel10-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>What topics or requests are not supported via chat?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    Atlas Chat is intended to support lead intelligence and
                    research queries. As with JO Enterprise Chat, please be
                    aware of the following when using Atlas Chat:
                  </p>
                  <ul className="ol-faq">
                    <li>
                      <strong>Legal or Contractual Matters:</strong> Responses
                      from Atlas Chat are not legally binding and do not
                      constitute legal advice. Always seek guidance from
                      JobsOhio's legal counsel before acting on any information
                      provided.
                    </li>
                    <li>
                      <strong>Accuracy &amp; Reliability:</strong> While Atlas
                      Chat strives for accuracy, responses are based on
                      available data and programmed logic. Always verify
                      information before relying on it.
                    </li>
                    <li>
                      <strong>IT &amp; Security:</strong> Use of Atlas Chat is
                      subject to JobsOhio's IT Usage and AI Governance policies.
                      Do not use the chat for security-sensitive matters, and be
                      aware that misuse may result in access restrictions or
                      disciplinary action.
                    </li>
                    <li>
                      <strong>Confidentiality &amp; Data Handling:</strong> In
                      compliance with the Standard of Conduct, do not share
                      sensitive personal or confidential company information in
                      Atlas Chat.
                    </li>
                    <li>
                      <strong>Compliance &amp; Policy:</strong> Atlas Chat does
                      not replace or take precedence over JobsOhio's policies,
                      processes, or compliance requirements. Always defer to
                      official guidance when in doubt.
                    </li>
                  </ul>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="atlas-panel11-content"
                id="atlas-panel11-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>Can I rate or give feedback on my chat experience?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    Yes! You can provide feedback at any time using the feedback
                    button located to the left of the chat window. For more
                    detailed or important feedback, you can also use the Contact
                    Us feature found in the Help Center within JOI. Your
                    feedback helps us continuously improve your Atlas Chat
                    experience.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="atlas-panel12-content"
                id="atlas-panel12-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>
                  What is Atlas Chat best suited for compared to JO Enterprise
                  Chat?
                </h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    Atlas Chat and JO-GPT (JobsOhio Enterprise Chat) serve
                    different purposes — here's how to know which to use:
                  </p>
                  <p>
                    <strong>Atlas Chat</strong> is your go-to for lead
                    intelligence and external data. Use it when you need to find
                    potential leads for Ohio, research organizations and people,
                    generate competitive landscape reports for any industry, or
                    find pathways to decision makers. Atlas Chat pulls from
                    JobsOhio Intelligence and external data sources to give you
                    a single view of leads, prospects, connections, legislation,
                    news, and events.
                  </p>
                  <p>
                    <strong>JO-GPT (JobsOhio Enterprise Chat)</strong> is a
                    general purpose internal AI tool best suited for day-to-day
                    productivity tasks. Use it to get info on projects won based
                    on core metrics, rewrite emails, summarize files hosted in
                    Box, or get quick answers from JOBIT talking points. JO-GPT
                    draws from internal sources including Box, JOBIT,
                    Salesforce, Tableau, and the JO Website.
                  </p>
                  <p>
                    In short — if your question is about external intelligence
                    and leads, use Atlas Chat. If it's about internal content,
                    projects, or drafting, use JO-GPT.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <div className="Faqscreen-sub-heading">
              <h3>About JOI</h3>
            </div>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>What is JOI?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    The JobsOhio Intelligence tool (JOI) enables the mission of
                    JobsOhio by leveraging the power of artificial intelligence
                    (AI) to identify organizations poised for growth and
                    expansion, easily identify decision makers, highlight simple
                    paths to connect with them, and provide competitive
                    intelligence on economic development opportunities.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>Who are the sponsors of JOI?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    <b>Executive Sponsors:</b> J.P. Nauseef, CEO & Andrew Deye,
                    Chief Financial Officer and Vice President, Strategy
                    <br></br>
                    <b>Primary Sponsor:</b> Payal Thakur, Senior Director –
                    Enterprise Analytics
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>What changes with the rollout of JOI?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>JOI is being designed to:</p>
                  <ul className="ol-faq">
                    <li>
                      Move employees from manual processes to an automated,
                      AI-driven solution
                    </li>
                    <li>
                      Consolidate existing apps, tools & data into one single
                      user interface
                    </li>
                    <li>
                      Leverage best-in-class data to ensure the people & company
                      information we are sourcing has breadth and consistency to
                      generate accurate and timely results
                    </li>
                  </ul>
                  <p>
                    <strong>JOI 2.0</strong> is targeted to be released in
                    November 2024 and April 2025 and will offer new features and
                    enhancements.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>Why JOI and why now?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    JobsOhio exists to empower world-class corporations,
                    entrepreneurs, and talented individuals to build their
                    businesses and careers in Ohio.
                  </p>
                  <ul className="ol-faq">
                    <li>
                      CEO, J.P. Nauseef’s vision was to empower JobsOhio
                      employees with intelligence that allows us to stay ahead
                      of the competition in terms of leads and pathways to
                      decision makers. Hence, we built an in-house tool,
                      leveraging AI, to give JobsOhio a strategic advantage.
                    </li>
                    <li>
                      84% of business executives believe they need to use AI to
                      achieve their growth objectives.
                    </li>
                    <li>
                      3 out of 4 C-suite executives believe if they don’t scale
                      artificial intelligence in the next five years, they risk
                      going out of business entirely.
                    </li>
                    <li>
                      AI adoption is growing faster than ever and has an ability
                      to process vast amounts of data, recognize patterns, and
                      make decisions or predictions with speed and accuracy far
                      beyond human capabilities.
                    </li>
                  </ul>
                  <p>
                    <strong>Proprietary only to JobsOhio, JOI</strong> will
                    streamline processes and give us a strategic advantage to
                    ensure we stay ahead of the competition.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>What are the benefits of using JOI?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <ul className="ol-faq">
                    <li>
                      Improves the user experience by streamlining apps, tools &
                      data into one simple tool
                    </li>
                    <li>
                      Eliminates manual and repetitive tasks, saving time to
                      focus on more strategic & creative solutions
                    </li>
                    <li>
                      Leverages enriched data and provides daily updates from
                      many data sources being used today
                    </li>
                    <li>
                      Reduces the need to use third-party vendors for lead
                      generation
                    </li>
                    <li>
                      Highlights connection paths fron JobsOhio employees to key
                      decision makers for essential relationship building
                      opportunities
                    </li>
                    <li>Generates leads in targeted industries/sectors</li>
                    <li>
                      Pushes relevant information to Salesforce (JOSF)
                      seamlessly
                    </li>
                  </ul>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3-content"
                id="panel3-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>What does success look like if JOI is adopted?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <ul className="ol-faq">
                    <li>
                      Awareness of the what, why, and what’s in it for me from
                      the pilot participants
                    </li>
                    <li>
                      Desire to participate in JOI (requesting access, logging
                      in, pushing to Salesforce, providing feedback)
                    </li>
                    <li>
                      Knowledge of how to use the tool & features (leveraging
                      job aids, videos, etc.)
                    </li>
                    <li>
                      Active use of the tool & features (logins, page visits,
                      active time spent in tool.)
                    </li>
                    <li>Increase in leads to projects to close</li>
                  </ul>
                </div>
              </AccordionDetails>
            </Accordion>
            <div className="Faqscreen-sub-heading">
              <h3>Technical/Security</h3>
            </div>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4-content"
                id="panel4-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>On which platform is JOI stored?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <ul className="ol-faq">
                    <li>
                      JOI is proprietary only to JobsOhio and is hosted on the
                      JobsOhio server. It is a web-based tool.
                    </li>
                  </ul>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>What is a data policy and is there one currently?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    A data policy describes how a business handles personal
                    data. It will highlight how the data is secure and the steps
                    taken to keep the information private. The data policy for
                    JobsOhio will be provided by Legal.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel6-content"
                id="panel6-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>What Data sources are used in JOI?</h4>
                {/* <h4>What data sources are used in the pilot version of JOI?</h4> */}
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <table>
                    <tbody>
                      <tr>
                        <td className="text-glossary">
                          <strong>INTERNAL APPLICATIONS</strong>
                        </td>
                        <td className="text-glossary">
                          <ul className="ol-faq">
                            {/* <li>Pardot</li> */}
                            <li>Salesforce</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-glossary">
                          <strong>DATA VENDORS</strong>
                        </td>
                        <td className="text-glossary">
                          <ul className="ol-faq">
                            <li>Crunchbase</li>
                            <li>
                              <a
                                href="https://lightcast.io/products/software/gazelle"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#4C87E2",
                                  textDecoration: "underline",
                                }}
                              >
                                Gazelle.AI
                              </a>
                            </li>
                            <li>Lighcast</li>
                            <li>ZoomInfo</li>
                            <li>PDL</li>
                            <li>State Net</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-glossary">
                          <strong>DATA QUALITY ENRICHMENT</strong>
                        </td>
                        <td className="text-glossary">
                          <ul className="ol-faq">
                            <li>Clearbit</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-glossary">
                          <strong>PUBLICLY AVAILABLE DATA</strong>
                        </td>
                        <td className="text-glossary">
                          <ul className="ol-faq">
                            <li>Extraction & Annotation via RPA</li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>How will JOI’s data be used?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <ul className="ol-faq">
                    <li>
                      Empowering growth through AI-driven, qualified lead
                      generation
                    </li>
                    <li>
                      Extending reach by identifying prospects who are potential
                      decision-makers within those organizations
                    </li>
                    <li>
                      Forging connections by identifying pathways to
                      decision-makers
                    </li>
                  </ul>
                  <div className="inner-imgfaq-mobile">
                    <img className="faqimg" src={faq1} alt="" />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>Is this information secure and protected?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    Yes, there are multi-factor authentication (MFA) methods to
                    keep data secure and protected via applications, such as
                    SOPHOS and OKTA.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>
                  Can JOI access personal information such as email content /
                  private messages?
                </h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    JOI does not have access to personal information such as
                    this; as it is only collecting metadata (which includes the
                    connection path, not the content).
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <div className="Faqscreen-sub-heading">
              <h3>JOI Capabilities</h3>
            </div>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel8-content"
                id="panel8-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>What is a JOI score?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    The JOI-Score is a measure of suitability, ranging from 0 to
                    100, that provides users with information on whether a
                    company is positioned for growth. This score is determined
                    by triggers identified by the BD NA team. A higher JOI-Score
                    indicates that the company is prepared to expand and
                    fulfills the criteria for growth.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel9-content"
                id="panel9-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>What is a JOI-Strength score?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    The JOI-Strength Score is a quantifiable measure developed
                    to assess the strength of connection between two
                    individuals, leveraging a sophisticated AI model. This model
                    intricately analyzes various dimensions of interpersonal
                    connections and provides a strength score between 0-100. The
                    higher the score, the stronger the connection.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel10-content"
                id="panel10-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>What is a New AI Lead Profile and how do I create one?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    An AI Lead Profile is a saved search that allows you to
                    quickly find leads using your predetermined filters.
                  </p>
                  <p>To create a new AI Lead Profile:</p>
                  <ul className="ol-faq">
                    <li>
                      View{" "}
                      <a href="https://app.box.com/shared/static/ogssxcjea5sl1qviz03p96yie0p6czui.pdf">
                        AI Lead Profile Job Aid
                      </a>
                    </li>
                    <li>
                      View{" "}
                      <a href="https://app.box.com/s/k9jxhk8as6nx6y87mmwen6ehl3kbcq8e">
                        AI Lead Profile Video
                      </a>
                    </li>
                  </ul>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel11-content"
                id="panel11-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>
                  How do I search for an organization and find my path to key
                  decision makers?
                </h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <ul className="ol-faq">
                    <li>
                      View{" "}
                      <a href="https://app.box.com/shared/static/oev320ly84jifp58chxuc8c9rj80x0wh.pdf">
                        Search an org/Find path Job Aid
                      </a>
                    </li>
                    <li>
                      View{" "}
                      <a href="https://app.box.com/s/qh9rgby8n5tyb8as4up34di1w0bcn53d">
                        Search an org/Find path Job Video
                      </a>
                    </li>
                  </ul>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>How do I push a lead to Salesforce?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <ol className="ol-faq">
                    <li>
                      User selects ALL Prospects for a given Lead by choosing
                      the 'Select All' option in the Prospect header OR chooses
                      individual Prospects by only selecting the checkbox next
                      to the desired Prospect{" "}
                    </li>
                    <li>
                      User selects the Action button in the upper right-hand
                      corner, then selects 'Push to Salesforce’
                    </li>
                  </ol>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel7-content"
                id="panel7-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>What is the definition of a connection?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    A relationship in which a person at JobsOhio is linked or
                    associated with another person at a potential client
                    company, either directly or indirectly.
                  </p>
                  <p>JOI provides several connection types, including:</p>
                  <ul className="ol-faq">
                    <li>Current Company Connection</li>
                    <li>Education Connection</li>
                    <li>Email Connection</li>
                    <li>Past Experience Connection</li>
                    <li>LinkedIn Connection</li>
                  </ul>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>
                  Will spam/marketing emails and/or your unengaged LinkedIn
                  contacts affect the tool’s outcome?
                </h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    No, JOI performs data quality checks to ensure that spam
                    accounts are filtered out. It will provide results based on
                    weight triggers. If you are not in frequent contact with a
                    LinkedIn contact or receive multiple emails from a spam
                    account, nothing should be negatively affected; regardless,
                    spam accounts will be filtered out.
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>How do I upload a file for data enrichment?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    The Data Enrich feature feature helps a user upload a list
                    of organizations or prospects to enrich with data that is
                    found within JOI or discovered through our data curation
                    process. Any organizations or prospects that are new to JOI
                    will be ingested into the tool and made available to all
                    users.
                  </p>
                  <p className="joi-training-vdo-faq">
                    {" "}
                    <img
                      src={dataenrich}
                      alt=""
                      onClick={() => openVideoOverview("DATA_ENRICH_VIDEO")}
                    />
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>
                  Where can I view Business Retention and Expansion information
                  for specific organizations?
                </h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    BRE provides a comprehensive, unified view that consolidates
                    essential account metrics in one place. This powerful tool
                    offers detailed location information, financial performance
                    metrics, historical BRE data, and relevant news updates -
                    all customized specifically for each BRE key account to
                    enable better business intelligence and decision-making.
                  </p>
                  <p className="joi-training-vdo-faq">
                    {" "}
                    <img
                      src={brevideologo}
                      alt=""
                      onClick={() => openVideoOverview("BRE_VIDEO")}
                    />
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>
                  Where can I view legislative information at a state or federal
                  level?
                </h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    JOI's new Legislative Map, a powerful tool that consolidates
                    state and federal laws related to economic development into
                    one comprehensive, user-friendly interface, enabling
                    effortless tracking and monitoring of legislation across the
                    country.
                  </p>
                  <p className="joi-training-vdo-faq">
                    {" "}
                    <img
                      src={mapframe}
                      alt=""
                      onClick={() => openVideoOverview("LEGISLATIVE_MAP_VIDEO")}
                    />
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <div className="Faqscreen-sub-heading">
              <h3>Additional Resources</h3>
            </div>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>Where can I find training on how to use JOI?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <ol className="ol-faq">
                    <li>
                      Check out{" "}
                      <a href="https://joi.jobsohio.com/joitraining">
                        JOI Training
                      </a>{" "}
                      in the left navigation panel for job aids & videos
                    </li>
                    <li>
                      <a href="https://app.smartsheet.com/b/home?lgt=wf&lrt=s&EQBCT=ecb4f8bd4aca4eb4943a2e2eaba3cbaf">
                        Click here
                      </a>{" "}
                      to schedule a 1:1 training with the Enterprise Data AI
                      Team.
                    </li>
                  </ol>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>Where can I learn more about the terms used in JOI?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    The JOI application provides a glossary of terms immediately
                    below this FAQ
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>Who do I contact if I have additional questions on JOI?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-seclast"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    Please feel free to contact our email:
                    <b>Enterprisedata@jobsohio.com</b>
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion className="defaultExpandedAccordion">
              <AccordionSummary
                className="AccordionSummary-innerheading-and-icon"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel12-content"
                id="panel12-header"
              >
                <span className="AccordionRedDot"></span>
                <h4>Where do I go if I want to provide feedback on JOI?</h4>
              </AccordionSummary>
              <AccordionDetails className="AccordionDetails-main">
                <div className="defaultAccordionline"></div>
                <div className="defaultAccordionRed-Line-last"></div>
                <div className="AccordionDetailsalldata">
                  <p>
                    Please submit your feedback through the{" "}
                    <a href="https://app.smartsheet.com/b/form/00c8c0047881489cbe8eedc3114921c1">
                      JOI Insights form
                    </a>
                    .
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>

      <Modal
        open={overviewVideoModal}
        onClose={handleCloseOverview}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modal-joiTraining-videos"
      >
        <Box sx={style} className="box-video-modals">
          <div className="box-section-relative">
            <div className="cross-icon-section" onClick={handleCloseOverview}>
              <CloseIcon />
            </div>
            <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
              <iframe
                src={VIDEO_LINKS[joiVideo]}
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "100%",
                  height: "100%",
                }}
                title="JOI PILOT Overview"
              ></iframe>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
